import { render, staticRenderFns } from "./basic-toolbar-layout.vue?vue&type=template&id=a9c4838a&scoped=true&"
import script from "./basic-toolbar-layout.vue?vue&type=script&lang=js&"
export * from "./basic-toolbar-layout.vue?vue&type=script&lang=js&"
import style0 from "./basic-toolbar-layout.vue?vue&type=style&index=0&id=a9c4838a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c4838a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VContainer,VMain})
